{{ matrixDetail.sortierung }} - {{ matrixDetail.bezeichnung }}<ng-container *ngIf="matrixDetail.ergaenzung"> ({{ matrixDetail.ergaenzung }})</ng-container>
